{
  "app.name": "Email Butler",
  "app.tagline": "Your mailboxes, under control.",
  "nav.today": "Today",
  "nav.attention": "Needs attention",
  "nav.decisions": "Decisions",
  "nav.allMail": "All mail",
  "nav.people": "People",
  "nav.money": "Money",
  "nav.family": "Family & school",
  "nav.documents": "Documents",
  "nav.subscriptions": "Subscriptions",
  "nav.waiting": "Waiting on",
  "nav.search": "Search",
  "nav.butler": "Butler",
  "nav.rescue": "Rescue",
  "nav.mailboxes": "Mailboxes",
  "nav.vault": "Safety Vault",
  "nav.activity": "Activity",
  "nav.settings": "Settings",
  "common.open": "Open",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.close": "Close",
  "common.retry": "Try again",
  "common.undo": "Undo",
  "common.approve": "Approve",
  "common.reject": "Reject",
  "common.remind": "Remind me",
  "common.handled": "Handled",
  "common.keep": "Keep",
  "common.loading": "Loading…",
  "common.language": "Language",
  "common.signOut": "Sign out",
  "today.greeting.morning": "Good morning",
  "today.greeting.afternoon": "Good afternoon",
  "today.greeting.evening": "Good evening",
  "today.attentionCount": {
    "zero": "Nothing needs your attention",
    "one": "{count} thing needs your attention",
    "other": "{count} things need your attention"
  },
  "today.deadlinesThisWeek": {
    "zero": "No deadlines this week",
    "one": "{count} deadline this week",
    "other": "{count} deadlines this week"
  },
  "today.peopleWaiting": {
    "zero": "Nobody is waiting for you",
    "one": "{count} person is waiting for you",
    "other": "{count} people are waiting for you"
  },
  "today.scope.all": "All mailboxes",
  "today.scope.label": "Show one mailbox",
  "mail.reply.title": "Reply",
  "mail.reply.placeholder": "Your reply, in your own words…",
  "mail.reply.send": "Send reply",
  "mail.reply.sendAll": "Reply to everyone",
  "mail.reply.sent": "Sent, and filed in your mailbox.",
  "mail.reply.failed": "Not sent. Nothing left your mailbox — try again.",
  "today.section.appointments": "Where you are due",
  "today.appointment.untitled": "(untitled meeting)",
  "today.appointment.unanswered": "not answered yet",
  "mail.title": "All mail",
  "mail.empty": "Nothing here yet. Mail appears as it syncs.",
  "mail.noSubject": "(no subject)",
  "mail.backToList": "Back to the list",
  "mail.openMessage": "Read this message",
  "mail.error.title": "Could not load your mail",
  "mail.remoteBlocked": "{count} remote resources were not loaded, so the sender was not told you opened this.",
  "today.progress.title": "Butler is working",
  "today.progress.classifying": "Getting to know your mail: {done} of {total} messages understood",
  "today.progress.firstPass": "The first pass is running. New batches land every quarter hour.",
  "today.progress.lastPass": "Last batch: {count} messages at {time}. The next lands within a quarter hour.",
  "today.progress.rescue": "Rescue analysis: {done} of {total} chunks across {messages} messages",
  "today.butlerHandled": {
    "zero": "Butler handled nothing else today",
    "one": "Butler handled {count} other message today",
    "other": "Butler handled {count} other messages today"
  },
  "today.empty.title": "You are all caught up",
  "today.empty.body": "Butler is watching your mailboxes. You will see something here when it actually needs you.",
  "today.reviewActivity": "Review activity",
  "mailbox.state.connected": "Connected",
  "mailbox.state.inventory": "Taking inventory",
  "mailbox.state.backingUp": "Creating safety snapshot",
  "mailbox.state.snapshotVerified": "Snapshot verified",
  "mailbox.state.rescuing": "Rescue in progress",
  "mailbox.state.active": "Up to date",
  "mailbox.state.degraded": "Needs attention",
  "mailbox.state.reauthRequired": "Reconnect needed",
  "mailbox.state.paused": "Paused",
  "mailbox.state.disconnected": "Disconnected",
  "mailbox.messageCount": {
    "one": "{count} message",
    "other": "{count} messages"
  },
  "vault.title": "Safety Vault",
  "vault.explainer": "Before Butler organises anything, it makes a verified copy it can put back.",
  "vault.protectedBy": "Protected by snapshot: {date}",
  "vault.status.verified": "Verified",
  "vault.status.pending": "Waiting to start",
  "vault.status.copying": "Copying",
  "vault.status.verifying": "Verifying",
  "vault.status.failed": "Failed",
  "onboarding.backup.title": "Protect this mailbox before Butler organises it",
  "onboarding.backup.full": "Full safety snapshot — recommended",
  "onboarding.backup.metadataOnly": "Metadata-only snapshot",
  "onboarding.backup.skip": "Continue without a snapshot",
  "onboarding.backup.skipWarning": "Without a snapshot, Butler cannot put messages back if something goes wrong. This cannot be undone later for actions taken before a snapshot exists.",
  "auth.signIn": "Sign in",
  "auth.signUp": "Create account",
  "auth.email": "Email address",
  "auth.password": "Password",
  "auth.mfaCode": "Verification code",
  "auth.forgotPassword": "Forgot your password?",
  "error.VALIDATION_FAILED": "Some of the details you entered need attention.",
  "error.MALFORMED_REQUEST": "That request could not be processed.",
  "error.UNSUPPORTED_MEDIA_TYPE": "That file type is not supported.",
  "error.IDEMPOTENCY_KEY_REUSED": "That action was already submitted.",
  "error.AUTHENTICATION_REQUIRED": "Please sign in to continue.",
  "error.AUTHENTICATION_FAILED": "Those sign-in details did not work.",
  "error.MFA_REQUIRED": "Enter your verification code to continue.",
  "error.SESSION_EXPIRED": "Your session expired. Please sign in again.",
  "error.PERMISSION_DENIED": "You do not have permission to do this.",
  "error.TENANT_MISMATCH": "That item belongs to a different workspace.",
  "error.NOT_FOUND": "We could not find that.",
  "error.CONFLICT": "This changed while you were working on it. Reload and try again.",
  "error.PRECONDITION_FAILED": "Something needs to happen first.",
  "error.POLICY_FORBIDS_ACTION": "Your workspace policy does not allow this.",
  "error.BACKUP_REQUIRED": "A verified snapshot is required before this action.",
  "error.CONFIRMATION_REQUIRED": "This needs your explicit confirmation.",
  "error.FEATURE_DISABLED": "This feature is switched off.",
  "error.RATE_LIMITED": "That is a lot of requests. Please wait a moment.",
  "error.PROVIDER_UNAVAILABLE": "Your mail provider is not responding right now. No mail has been lost.",
  "error.AI_UNAVAILABLE": "Butler's analysis is paused. Your mail keeps syncing and nothing has been deleted.",
  "error.INTERNAL_ERROR": "Something went wrong on our side. Your mail is safe.",
  "error.SERVICE_UNAVAILABLE": "Email Butler is temporarily unavailable.",
  "error.reference": "Reference: {requestId}",
  "auth.signIn.title": "Welcome back",
  "auth.signIn.subtitle": "Sign in to your workspaces.",
  "auth.signIn.submit": "Sign in",
  "auth.signIn.noAccount": "No account yet?",
  "auth.register.title": "Create your account",
  "auth.register.subtitle": "One account, every mailbox you own.",
  "auth.register.submit": "Create account",
  "auth.register.hasAccount": "Already have an account?",
  "auth.register.sent.title": "Check your email",
  "auth.register.sent.body": "If that address can be used, we have sent a verification link to it.",
  "auth.register.passwordHint": "At least {count} characters. Length matters more than symbols.",
  "auth.registration.invitationOnly": "Accounts are currently created by an administrator.",
  "auth.registration.closed.title": "Registration is invitation only",
  "auth.registration.closed.body": "Public signup is disabled while Email Butler is being tested. Ask the administrator to create your account.",
  "auth.displayName": "Your name",
  "auth.newPassword": "New password",
  "auth.currentPassword": "Current password",
  "auth.verify.title": "Verifying your email",
  "auth.verify.success": "Your email address is verified. You can sign in now.",
  "auth.verify.failed": "That verification link is invalid or has expired.",
  "auth.forgot.title": "Reset your password",
  "auth.forgot.subtitle": "We will send a link if the address has an account.",
  "auth.forgot.submit": "Send reset link",
  "auth.forgot.sent": "If that address has an account, a reset link is on its way.",
  "auth.reset.title": "Choose a new password",
  "auth.reset.submit": "Set new password",
  "auth.reset.success": "Your password is updated. Sign in with it now.",
  "auth.mfa.title": "One more step",
  "auth.mfa.subtitle": "Enter the code from your authenticator app, or a recovery code.",
  "auth.mfa.submit": "Verify",
  "auth.backToSignIn": "Back to sign in",
  "auth.unreachable.title": "We cannot reach Email Butler",
  "auth.unreachable.body": "Your mail is untouched. This is a connection problem, not a sign-out.",
  "security.title": "Security",
  "security.mfa.title": "Two-factor authentication",
  "security.mfa.enabled": "Enabled",
  "security.mfa.disabled": "Not enabled",
  "security.mfa.explainer": "A second factor protects every mailbox you have connected. We strongly recommend it.",
  "security.mfa.enable": "Enable two-factor",
  "security.mfa.disable": "Turn off two-factor",
  "security.mfa.scan": "Scan this in your authenticator app, or enter the key by hand.",
  "security.mfa.confirm": "Confirm code",
  "security.mfa.recoveryTitle": "Save your recovery codes",
  "security.mfa.recoveryBody": "Each code works once. Keep them somewhere safe — they are the only way back in if you lose your device. We cannot show them again.",
  "security.mfa.recoveryRemaining": {
    "one": "{count} recovery code left",
    "other": "{count} recovery codes left"
  },
  "security.sessions.title": "Signed-in devices",
  "security.sessions.current": "This device",
  "security.sessions.lastSeen": "Last used {when}",
  "security.sessions.revoke": "Sign out",
  "security.password.title": "Password",
  "security.password.change": "Change password",
  "security.password.changed": "Your password is updated. Other devices have been signed out.",
  "workspace.switch": "Workspace",
  "workspace.none.title": "No workspace yet",
  "workspace.none.body": "You are signed in but do not belong to a workspace. Ask an owner to invite you, or create one.",
  "command.open": "Search and commands",
  "command.placeholder": "Search or jump to…",
  "command.empty": "Nothing matches that.",
  "command.section.navigate": "Go to",
  "command.section.actions": "Actions",
  "command.action.toggleTheme": "Switch between light and dark",
  "command.action.signOut": "Sign out",
  "workspace.create.title": "Create your workspace",
  "workspace.create.body": "A workspace holds your mailboxes, your rules and your history. You can invite people to it later.",
  "workspace.create.name": "Workspace name",
  "workspace.create.slug": "Address",
  "workspace.create.slugHint": "Lowercase letters, digits and hyphens. This appears in links.",
  "workspace.create.submit": "Create workspace",
  "passkey.title": "Passkeys",
  "passkey.explainer": "A passkey signs you in with your device — face, fingerprint or PIN. It cannot be phished: your browser will not hand it to a lookalike site.",
  "passkey.add": "Add a passkey",
  "passkey.signIn": "Sign in with a passkey",
  "passkey.none": "No passkeys yet.",
  "passkey.remove": "Remove",
  "passkey.added": "Added {when}",
  "passkey.lastUsed": "Last used {when}",
  "passkey.neverUsed": "Never used",
  "passkey.synced": "Synced across your devices",
  "passkey.singleDevice": "This device only",
  "passkey.unsupported": "This browser does not support passkeys.",
  "passkey.cancelled": "That was cancelled. Nothing has changed.",
  "proposal.title.archive_bulk_sender": {
    "one": "Archive {count} message from {sender}",
    "other": "Archive {count} messages from {sender}"
  },
  "proposal.title.archive_notifications": {
    "one": "Archive {count} old notification from {sender}",
    "other": "Archive {count} old notifications from {sender}"
  },
  "proposal.title.mark_historical_read": {
    "one": "Mark {count} old unread message from {sender} as read",
    "other": "Mark {count} old unread messages from {sender} as read"
  },
  "proposal.title.reorganize_category": {
    "one": "Move {count} {category} message to {folder}",
    "other": "Move {count} {category} messages to {folder}"
  },
  "proposal.title.keep_transactions": "Never offer {subject} for cleanup",
  "proposal.undo.archive_bulk_sender": "Undo puts every message back in the folder it was in. Nothing is deleted.",
  "proposal.undo.archive_notifications": "Undo puts every message back in the folder it was in. Nothing is deleted.",
  "proposal.undo.mark_historical_read": "Undo marks them unread again. Nothing is moved or deleted.",
  "proposal.undo.reorganize_category": "Undo moves every message back where it was.",
  "proposal.undo.keep_transactions": "Nothing changes. Remove the exception to be offered this again.",
  "proposal.safety.safe": "Safe",
  "proposal.safety.probably_safe": "Probably safe",
  "proposal.safety.ask": "Worth a look",
  "proposal.protectedBy": "Protected by the backup of {date}",
  "proposal.notCovered": {
    "one": "{count} message is not in the backup yet",
    "other": "{count} messages are not in the backup yet"
  },
  "proposal.examplesHeading": "For example",
  "proposal.review.approve_all": {
    "one": "Approve {proposals} proposal, covering {messages} messages",
    "other": "Approve all {proposals} proposals, covering {messages} messages"
  },
  "proposal.review.too_many_to_approve": "That is {messages} messages across {proposals} proposals. Approve them in groups of at most {limit}.",
  "proposal.review.decided": {
    "one": "{count} proposal approved",
    "other": "{count} proposals approved"
  },
  "proposal.review.empty": "Nothing is waiting for you.",
  "proposal.exclusion.heading": "Never cleaned up",
  "proposal.exclusion.added": "{value} will not be offered for cleanup again.",
  "proposal.exclusion.removed": "{value} can be offered for cleanup again.",
  "today.headline.clear": {
    "zero": "Nothing needs you",
    "one": "Nothing needs you. Butler filed {count} message",
    "other": "Nothing needs you. Butler filed {count} messages"
  },
  "today.headline.attention": {
    "one": "{count} message needs you",
    "other": "{count} messages need you"
  },
  "today.headline.deadlines": {
    "one": "{count} deadline coming up",
    "other": "{count} deadlines coming up"
  },
  "today.headline.overdue": {
    "one": "{count} thing is overdue",
    "other": "{count} things are overdue"
  },
  "today.headline.waiting": {
    "one": "{count} person is waiting on you",
    "other": "{count} people are waiting on you"
  },
  "today.headline.needsFixing": {
    "one": "{count} thing needs fixing before Butler can work",
    "other": "{count} things need fixing before Butler can work"
  },
  "today.section.attention": "Needs you",
  "today.section.deadlines": "Deadlines",
  "today.section.waitingOnYou": "Waiting on you",
  "today.section.waitingOnOthers": "You are waiting on",
  "today.section.handled": "Butler handled",
  "today.section.health": "Your mailboxes",
  "today.section.vault": "Safety Vault",
  "today.deadline.due": {
    "one": "Due in {count} day",
    "other": "Due in {count} days"
  },
  "today.deadline.dueToday": "Due today",
  "today.deadline.overdue": {
    "one": "{count} day overdue",
    "other": "{count} days overdue"
  },
  "today.waiting.since": {
    "one": "Waiting {count} day",
    "other": "Waiting {count} days"
  },
  "today.handled.filed": {
    "zero": "Nothing filed",
    "one": "{count} message filed",
    "other": "{count} messages filed"
  },
  "today.handled.proposals": {
    "one": "{count} cleanup carried out",
    "other": "{count} cleanups carried out"
  },
  "today.handled.unsubscribes": {
    "one": "{count} unsubscribe sent",
    "other": "{count} unsubscribes sent"
  },
  "today.handled.undoable": {
    "zero": "Nothing left to undo",
    "one": "{count} of these can still be undone",
    "other": "{count} of these can still be undone"
  },
  "today.health.ok": "Syncing normally",
  "today.health.stale": "{mailbox} has not synced for {hours} hours",
  "today.health.neverSynced": "{mailbox} has never synced",
  "today.health.disconnected": "{mailbox} is disconnected",
  "today.health.degraded": "{mailbox} is having trouble",
  "today.health.paused": "{mailbox} is paused",
  "today.health.reauthRequired": "{mailbox} needs you to sign in again",
  "today.vault.ok": "Backed up and verified",
  "today.vault.none": "{mailbox} has no verified backup yet. Butler will not clean anything until it does.",
  "today.vault.ageing": "The backup of {mailbox} is {days} days old",
  "today.vault.stale": "The backup of {mailbox} is {days} days old and needs refreshing",
  "today.vault.verified": "Verified {date}",
  "today.error.title": "Today could not be loaded",
  "today.error.body": "Rather than show you a calm screen we cannot stand behind, here is the problem.",
  "today.retry": "Try again",
  "decision.queue.title": "Waiting on you",
  "decision.queue.empty": "Butler has nothing to ask you.",
  "decision.queue.counts": "{high} high risk, {medium} medium, {low} low",
  "decision.risk.low": "Low risk",
  "decision.risk.medium": "Worth a look",
  "decision.risk.high": "High risk",
  "decision.autoApproved": "Butler did this without asking",
  "decision.reversible": "Can be undone",
  "decision.irreversible": "Cannot be undone",
  "decision.preview.showing": {
    "one": "Showing {count} of {total}",
    "other": "Showing {count} of {total}"
  },
  "decision.preview.showingAll": {
    "one": "All {total}",
    "other": "All {total}"
  },
  "decision.approve": "Yes, do it",
  "decision.reject": "No",
  "decision.approveAll": "Approve these",
  "decision.rejectAll": "Not now",
  "decision.highRiskAlone": "High-risk decisions are answered on their own.",
  "decision.why.title": "Why not?",
  "decision.why.never_again": "Never suggest this again",
  "decision.why.not_now": "Not right now",
  "decision.why.wrong_subject": "This is about the wrong thing",
  "decision.why.wrong_value": "Right idea, wrong details",
  "decision.why.too_risky": "Too much at once",
  "decision.title.cleanup": {
    "one": "Archive {count} message from {sender}",
    "other": "Archive {count} messages from {sender}"
  },
  "decision.preview.cleanup": "Archive {total} messages from {sender}",
  "decision.title.unsubscribe": "Unsubscribe from {sender}",
  "decision.title.mark_read": {
    "one": "Mark {count} message from {sender} as read",
    "other": "Mark {count} messages from {sender} as read"
  },
  "decision.undo.archive": "Undo puts every message back in the folder it was in.",
  "decision.undo.mark_read": "Undo marks them unread again.",
  "decision.preview.archive": {
    "one": "{count} message would move to the archive",
    "other": "{count} messages would move to the archive"
  },
  "decision.error.conflict": "Someone already answered this.",
  "decision.error.title": "The queue could not be loaded",
  "triage.start": "Triage one by one",
  "triage.backToList": "Back to the list",
  "triage.progress": "{done} of {total} answered",
  "triage.done.title": "Queue triaged.",
  "triage.hint.swipe": "Swipe right to approve, left for not now.",
  "triage.hint.deliberate": "This one is deliberate: use the buttons.",
  "triage.hint.keys": "Keys: a approve · n not now · r no, because · z undo",
  "triage.hint.keysDeliberate": "Keys: n not now · r no, because — approving this one takes the button.",
  "triage.toast.approved": "Approved — sending in a moment.",
  "triage.toast.deferred": "Deferred — sending in a moment.",
  "triage.toast.undo": "Undo",
  "rule.template.school.name": "School mail",
  "rule.template.school.description": "Mail from your children's schools is marked important and is never cleaned up or unsubscribed from. School mail looks like bulk mail to every automatic signal, and the one that matters is the one about the trip on Thursday.",
  "rule.template.family.name": "Family and health",
  "rule.template.family.description": "Mail about your family, your children and your health is marked important and protected from cleanup.",
  "rule.template.money.name": "Bills and deadlines",
  "rule.template.money.description": "Anything that needs paying stays in your inbox and is marked important. Nothing is filed away: a bill you cannot see is a bill you do not pay.",
  "rule.preview.matched": {
    "zero": "This would not have matched anything",
    "one": "This would have matched {count} message in the last {days} days",
    "other": "This would have matched {count} messages in the last {days} days"
  },
  "rule.warning.catches_answered_mail": {
    "one": "It would have filed {count} message you replied to",
    "other": "It would have filed {count} messages you replied to"
  },
  "rule.warning.catches_almost_everything": "This matches most of your mail. That is usually a condition catching something in every footer.",
  "rule.warning.catches_nothing": "This matched nothing. Check the address or domain before you switch it on.",
  "rule.warning.moves_mail": "This moves mail out of your inbox.",
  "rule.warning.small_sample": "There is not much history yet, so this preview does not tell you much.",
  "rule.enabled": "On",
  "rule.disabled": "Off",
  "rule.dormant": "Has never matched anything",
  "rule.explain.title": "Why is this message here?",
  "menu.about": "About Email Butler",
  "menu.settings": "Settings",
  "menu.signOut": "Sign out",
  "menu.openNavigation": "Open navigation",
  "menu.closeNavigation": "Close navigation",
  "menu.quit": "Quit",
  "menu.go": "Go",
  "menu.commandPalette": "Command palette",
  "menu.mailbox": "Mailbox",
  "menu.syncNow": "Sync now",
  "menu.help": "Help",
  "menu.documentation": "Documentation",
  "menu.revealLogs": "Show logs",
  "menu.checkForUpdates": "Check for updates",
  "update.available": "Version {version} is ready. It will install next time you open Email Butler.",
  "update.notes": "What changed",
  "native.signedOutTitle": "You are signed out",
  "native.signedOutBody": "This machine has no place to keep your session safely, so you will be asked to sign in each time.",
  "native.deepLinkRefused": "That link could not be opened.",
  "notify.critical_message.title": "Something needs you",
  "notify.critical_message.body": "A message arrived that Butler could not handle.",
  "notify.deadline_near.title": "A deadline is close",
  "notify.deadline_near.body": "Something is due in the next two days.",
  "notify.payment_failed.title": "A payment failed",
  "notify.payment_failed.body": "One of your payments did not go through.",
  "notify.mailbox_broken.title": "A mailbox needs you",
  "notify.mailbox_broken.body": "Butler cannot reach one of your mailboxes.",
  "notify.run_finished.title": "Butler has finished",
  "notify.run_finished.body": "The run you started is done.",
  "notify.quietHours": "Butler stays quiet between {from}:00 and {to}:00.",
  "shortcut.reserved": "Your system already uses that shortcut.",
  "shortcut.needsModifier": "A global shortcut needs a modifier key.",
  "mobile.noScreenLock": "This phone has no screen lock, so anybody holding it can read your mail. Set one in your phone's settings.",
  "mobile.noHardwareKeystore": "This phone stores your session in software rather than in secure hardware. It is still protected by your screen lock.",
  "mobile.offlineNotice": "You are offline. This is the last {days} days of mail; anything else will load when you have a connection.",
  "mobile.lockedTitle": "Locked",
  "mobile.lockedBody": "Unlock to see your mail.",
  "mobile.undo": "Undo",
  "mobile.swipeArchived": "Archived",
  "mobile.swipeSnoozed": "Snoozed",
  "mobile.unlock": "Unlock",
  "push.decisionWaiting": "{count, plural, one {# decision is waiting} other {# decisions are waiting}}",
  "push.rescueComplete": "Your mailbox rescue has finished",
  "push.snapshotFailed": "A Safety Vault snapshot did not complete",
  "push.syncBroken": "A mailbox has stopped syncing",
  "push.deadlineToday": "{count, plural, one {# deadline is due today} other {# deadlines are due today}}",
  "autonomy.title": "What Butler may do on its own",
  "autonomy.intro": "Butler asks before anything you have not agreed to. Change that here, one kind of help at a time.",
  "autonomy.pause.title": "Stop everything",
  "autonomy.pause.body": "Butler keeps reading and suggesting, and stops changing anything, for a week.",
  "autonomy.pause.active": "Butler is paused. It is still reading and suggesting, and it is changing nothing.",
  "autonomy.pause.stop": "Pause Butler",
  "autonomy.pause.resume": "Let Butler continue",
  "autonomy.levels.title": "The four levels",
  "autonomy.level.0.title": "Observe",
  "autonomy.level.0.body": "Butler reads and suggests. Nothing in your mailbox changes unless you say so.",
  "autonomy.level.1.title": "Organise",
  "autonomy.level.1.body": "Filing, labels, marking read, archiving. All of it can be undone.",
  "autonomy.level.2.title": "Manage",
  "autonomy.level.2.body": "Unsubscribing and cleaning up. An unsubscribe cannot be taken back.",
  "autonomy.level.3.title": "Act outside",
  "autonomy.level.3.body": "Sending mail as you. Somebody else reads it, and no undo reaches them.",
  "autonomy.capabilities.title": "Kinds of help",
  "autonomy.capability.organise": "Filing and labelling",
  "autonomy.capability.archive": "Archiving",
  "autonomy.capability.mark_read": "Marking read",
  "autonomy.capability.draft": "Preparing replies",
  "autonomy.capability.unsubscribe": "Unsubscribing",
  "autonomy.capability.cleanup": "Cleaning up old mail",
  "autonomy.capability.remind": "Reminders",
  "autonomy.capability.send": "Sending mail",
  "autonomy.capability.delete": "Deleting permanently",
  "autonomy.capability.needs": "Needs level {level} or higher",
  "autonomy.refusals.title": "What Butler held back",
  "autonomy.refusals.none": "Butler has not held anything back this week.",
  "autonomy.refusal.permission": "{count, plural, one {# time, because you are not allowed that action} other {# times, because you are not allowed that action}}",
  "autonomy.refusal.paused": "{count, plural, one {# time, because Butler is paused} other {# times, because Butler is paused}}",
  "autonomy.refusal.never_touch": "{count, plural, one {# time, because you asked Butler never to touch that sender} other {# times, because you asked Butler never to touch those senders}}",
  "autonomy.refusal.feature_flag": "{count, plural, one {# time, because that feature is switched off} other {# times, because that feature is switched off}}",
  "autonomy.refusal.trust_level": "{count, plural, one {# time, because you have not agreed to that yet} other {# times, because you have not agreed to that yet}}",
  "autonomy.refusal.confidence": "{count, plural, one {# time, because Butler was not sure enough} other {# times, because Butler was not sure enough}}",
  "autonomy.refusal.no_snapshot": "{count, plural, one {# time, because there is no verified backup to fall back on} other {# times, because there is no verified backup to fall back on}}",
  "autonomy.error.title": "Could not load your settings",
  "autonomy.error.body": "Nothing has changed. Try again in a moment.",
  "nav.autonomy": "Butler settings",
  "health.authRequired": "This mailbox needs reconnecting. Mail is not arriving.",
  "health.syncStalled": "No new mail seen for {hours} hours.",
  "health.noSnapshot": "There is no verified backup of this mailbox yet.",
  "health.snapshotStale": "The last verified backup is {days} days old.",
  "health.quotaNear": "This mailbox is {percent}% full. It stops receiving mail when it is full.",
  "health.unsubscribeFailing": "{count, plural, one {# unsubscribe did not go through} other {# unsubscribes did not go through}}",
  "health.backlogGrowing": "{count, plural, one {# message older than a week is still unread} other {# messages older than a week are still unread}}",
  "digest.problems": "{count, plural, one {# thing needs fixing} other {# things need fixing}}",
  "digest.needs_you": "{count, plural, one {# thing needs you} other {# things need you}}",
  "digest.handled": "{count, plural, one {Butler handled # thing} other {Butler handled # things}}",
  "digest.money": "{count, plural, one {# payment to look at} other {# payments to look at}}",
  "digest.subscriptions": "{count, plural, one {# subscription changed} other {# subscriptions changed}}",
  "digest.backlog": "{count, plural, one {# older message is still unread} other {# older messages are still unread}}",
  "digest.more": "and {total} more",
  "subscription.price_increase": "The price went up.",
  "subscription.charge_missed": "No charge for {days} days. It may have been cancelled.",
  "subscription.renewal_soon": "Renews in {days} days.",
  "subscription.trial_ending": "The trial ends in {days} days.",
  "subscription.payment_failed": "The last payment failed.",
  "subscription.dormant": "Nothing charged for {days} days.",
  "anomaly.volume_spike": "Much more mail than usual today.",
  "anomaly.sender_burst": "Unusually many messages from one sender.",
  "anomaly.sync_stalled": "This mailbox has stopped syncing.",
  "anomaly.auth_failing": "This mailbox can no longer sign in.",
  "anomaly.bulk_deletion": "An unusual number of messages were removed.",
  "anomaly.unsubscribe_failures": "Several unsubscribes did not go through.",
  "anomaly.snapshot_stale": "The backup of this mailbox is out of date.",
  "plan.free": "Free",
  "plan.personal": "Personal",
  "plan.family": "Family",
  "plan.business": "Business",
  "plan.selfHosted": "Self-hosted",
  "meter.mailboxes": "Mailboxes",
  "meter.users": "People",
  "meter.storage_bytes": "Mail stored",
  "meter.vault_storage_bytes": "Safety Vault",
  "meter.messages_indexed": "Messages indexed",
  "meter.ai_tokens": "Butler thinking",
  "meter.unlimited": "No limit",
  "meter.approaching": "Nearly at the limit",
  "meter.atLimit": "At the limit",
  "meter.over": "Over the limit",
  "meter.neverEnforced": "Measured, never a reason to stop",
  "billing.title": "Plan and usage",
  "billing.downgradeConflict": "Changing to this plan would put you over the limit on {meter}.",
  "preflight.os.ok": "Operating system: Ubuntu {version}",
  "preflight.os.untested": "{os} is untested. The stack is containers and will probably run, but Ubuntu LTS is what we test.",
  "preflight.os.version": "Ubuntu {version} is untested. Supported: {supported}.",
  "preflight.architecture.ok": "Architecture: {architecture}",
  "preflight.architecture.unsupported": "No images are built for {architecture}.",
  "preflight.memory.ok": "Memory: {found} MB",
  "preflight.memory.tight": "Memory: {found} MB. {recommended} MB is recommended.",
  "preflight.memory.tooSmall": "Memory: {found} MB. {needed} MB is the minimum.",
  "preflight.disk.ok": "Disk free: {found} GB",
  "preflight.disk.tight": "Disk free: {found} GB. The Safety Vault holds a full copy of every mailbox, so {recommended} GB is recommended.",
  "preflight.disk.tooSmall": "Disk free: {found} GB. {needed} GB is the minimum.",
  "preflight.cpu.ok": "CPU cores: {found}",
  "preflight.cpu.tooFew": "CPU cores: {found}. {needed} is the minimum.",
  "preflight.docker.ok": "Docker {version}",
  "preflight.docker.missing": "Docker is not installed.",
  "preflight.docker.tooOld": "Docker {version} is too old. Version {needed} or newer is needed.",
  "preflight.compose.ok": "Docker Compose {version}",
  "preflight.compose.missing": "The Docker Compose plugin is not available.",
  "preflight.ports.ok": "Ports 80 and 443 are free",
  "preflight.ports.taken": "Something is already listening on {ports}.",
  "preflight.dns.ok": "The domain resolves to this machine",
  "preflight.dns.unknown": "Could not check whether the domain resolves here. Certificates will fail if it does not.",
  "preflight.dns.mismatch": "The domain does not appear to resolve to this machine. That is normal behind NAT, and fatal otherwise.",
  "preflight.clock.ok": "The clock is accurate",
  "preflight.clock.skewed": "The clock is {seconds} seconds out. Certificates, sign-in and two-factor codes will all fail.",
  "preflight.overcommit.ok": "Kernel memory settings are fine",
  "preflight.overcommit.strict": "vm.overcommit_memory is strict. Redis and PostgreSQL can fail under memory pressure in ways that look like application bugs.",
  "health.allOk": "Everything is fine.",
  "health.migrations.ok": "The database schema is current",
  "health.migrations.pending": "{count} migration(s) have not been applied",
  "health.migrations.remedy": "Run ./upgrade.sh, or: docker compose run --rm migrate",
  "health.disk.ok": "Disk usage is fine",
  "health.disk.filling": "The disk is {percent}% full",
  "health.disk.full": "The disk is {percent}% full. PostgreSQL will stop writing and snapshots will stop.",
  "health.disk.remedy": "Free space now. Check the backup directory and run: docker system prune",
  "health.tls.ok": "The certificate is valid for {days} more days",
  "health.tls.unknown": "TLS is handled elsewhere",
  "health.tls.expiring": "The certificate expires in {days} days and has not renewed",
  "health.tls.expired": "The certificate has expired",
  "health.tls.remedy": "Check that port 80 is reachable: renewal answers its challenge there.",
  "health.backups.ok": "A recent verified backup exists",
  "health.backups.old": "The newest backup is {days} days old",
  "health.backups.stale": "The newest backup is {days} days old",
  "health.backups.none": "No backup has ever been taken. Butler cannot put anything back.",
  "health.backups.remedy": "Run ./backup.sh, then add it to cron.",
  "onboarding.position": "Step {position} of {total}",
  "onboarding.skip": "Skip this",
  "onboarding.goToMail": "Take me to my mail",
  "onboarding.longWait": "This will take a while. You can close this and we will carry on without you.",
  "onboarding.done.title": "All set",
  "onboarding.done.body": "Butler is working. Today will show you anything that needs you.",
  "onboarding.error.title": "Something went wrong",
  "onboarding.error.body": "Nothing has been lost. Try again in a moment.",
  "onboarding.progress.counting": "Counting what is in your mailbox.",
  "onboarding.progress.starting": "{done} of {total} so far.",
  "onboarding.progress.working": "{done} of {total}, about {minutes} minutes left.",
  "onboarding.purpose.createTenant": "Somewhere to keep everything Butler learns.",
  "onboarding.purpose.privacy": "Whether your mail may leave this machine.",
  "onboarding.purpose.connectMailbox": "The mailbox Butler will look after.",
  "onboarding.purpose.permissions": "What you allowed the provider to share.",
  "onboarding.purpose.inventory": "Finding out what is there.",
  "onboarding.purpose.vaultSnapshot": "A copy Butler can put back.",
  "onboarding.purpose.firstFindings": "The first things worth your attention.",
  "onboarding.purpose.rescue": "Working through the backlog.",
  "onboarding.purpose.decisions": "How Butler asks when it is unsure.",
  "onboarding.purpose.today": "The screen you will actually use.",
  "onboarding.step.create_tenant.title": "Name your workspace",
  "onboarding.step.create_tenant.body": "Everything Butler learns lives here. You can rename it later.",
  "onboarding.step.create_tenant.action": "Create workspace",
  "onboarding.step.privacy_preference.title": "Where should Butler think?",
  "onboarding.step.privacy_preference.body": "Butler can run entirely on your own machine, or use a larger model elsewhere for harder questions. Local is the default and you can change it whenever you like.",
  "onboarding.step.privacy_preference.action": "Keep it local",
  "onboarding.step.connect_mailbox.title": "Connect a mailbox",
  "onboarding.step.connect_mailbox.body": "Butler reads your mail to organise it. It never sends anything without asking you first.",
  "onboarding.step.connect_mailbox.action": "Connect",
  "onboarding.step.explain_permissions.title": "What you just allowed",
  "onboarding.step.explain_permissions.body": "Butler can read your mail, move it between folders and mark it read. It cannot send, and it cannot delete anything permanently.",
  "onboarding.step.explain_permissions.action": "Got it",
  "onboarding.step.inventory.title": "Looking through your mailbox",
  "onboarding.step.inventory.body": "Counting what is there. On a large mailbox this takes a while, and you can leave this page.",
  "onboarding.step.inventory.action": "Continue",
  "onboarding.step.vault_snapshot.title": "Making a copy first",
  "onboarding.step.vault_snapshot.body": "Before Butler cleans anything, it makes a copy it can put back. Nothing is touched until this finishes.",
  "onboarding.step.vault_snapshot.action": "Continue",
  "onboarding.step.first_findings.title": "What Butler found",
  "onboarding.step.first_findings.body": "The first things worth your attention. Nothing has been changed yet.",
  "onboarding.step.first_findings.action": "Show me",
  "onboarding.step.rescue_start.title": "Clean up the backlog",
  "onboarding.step.rescue_start.body": "Butler will work through years of old mail and ask before anything that cannot be undone.",
  "onboarding.step.rescue_start.action": "Start",
  "onboarding.step.decision_tutorial.title": "How Butler asks",
  "onboarding.step.decision_tutorial.body": "When Butler is unsure, it asks. Each question says what it would do and how many messages it affects.",
  "onboarding.step.decision_tutorial.action": "Understood",
  "onboarding.step.today.title": "You are set up",
  "onboarding.step.today.body": "Today shows what needs you. Silence means Butler handled it.",
  "onboarding.step.today.action": "Go to Today",
  "onboarding.waiting.title": "Butler is still working",
  "onboarding.waiting.body": "This step continues in the background. You can leave this page and come back; it will advance automatically when ready.",
  "rescue.title": "Rescue",
  "rescue.intro": "Analyse the backlog safely before deciding what to organise. This release only reads indexed metadata and never changes provider mail.",
  "rescue.noMailbox": "Connect a mailbox before starting Rescue.",
  "rescue.mailbox": "Mailbox",
  "rescue.waitForSnapshot": "Rescue becomes available after the first Safety Vault snapshot is verified.",
  "rescue.startAnalysis": "Start safe analysis",
  "rescue.startUpdatedAnalysis": "Analyse {count} indexed messages",
  "rescue.newMessagesIndexed": "New mail has been indexed since this analysis. Run Rescue again to include all {count} indexed messages.",
  "rescue.pause": "Pause",
  "rescue.resume": "Resume",
  "rescue.cancel": "Cancel",
  "rescue.status.title": "Analysis status",
  "rescue.status.planning": "Planning",
  "rescue.status.awaiting_backup": "Waiting for Safety Vault",
  "rescue.status.ready": "Ready",
  "rescue.status.running": "Analysing",
  "rescue.status.paused": "Paused",
  "rescue.status.completed": "Completed",
  "rescue.status.failed": "Needs attention",
  "rescue.status.cancelled": "Cancelled",
  "rescue.progress": "{processed} of {total} messages analysed",
  "rescue.findings": "Findings",
  "rescue.findings.empty": "No findings yet. Results appear while the analysis runs.",
  "rescue.finding.bulk_sender": "Sender",
  "rescue.finding.unpaid_obligation": "Unpaid obligation",
  "rescue.finding.stale_thread": "Stale unanswered mail",
  "rescue.finding.unanswered_question": "Unanswered question",
  "rescue.finding.large_attachment": "Large attachments",
  "rescue.finding.security_event": "Security signal",
  "rescue.finding.duplicate_group": "Duplicates",
  "rescue.finding.old_unread": "Old unread mail",
  "rescue.finding.subscription": "Subscription",
  "rescue.finding.count": "{count} messages",
  "a11y.skipToContent": "Skip to content",
  "network.offline": "You are offline. What is on screen is from a moment ago.",
  "network.offlineStale": "You are offline and this screen may be out of date.",
  "network.reconnecting": "Reconnecting.",
  "network.degraded": "The connection is slow. Some things may take longer.",
  "error.offline.title": "No connection",
  "error.offline.body": "We will pick up where we left off when you are back online.",
  "error.rateLimited.title": "Too fast",
  "error.rateLimited.body": "Give it a moment and it will carry on by itself.",
  "error.signedOut.title": "You have been signed out",
  "error.signedOut.body": "Sign in again to carry on. Nothing has been lost.",
  "error.notAllowed.title": "Not allowed",
  "error.notAllowed.body": "Your role does not include this. An administrator can change it.",
  "error.gone.title": "That is no longer there",
  "error.gone.body": "It may have been moved or deleted. Reload to see the current state.",
  "error.invalid.title": "Something in that is not right",
  "error.invalid.body": "Check the highlighted field and try again.",
  "error.changed.title": "Somebody changed this",
  "error.changed.body": "Reload before saving, so you do not overwrite their change.",
  "error.mailboxDown.title": "The mail provider is not responding",
  "error.mailboxDown.body": "We will keep trying. Nothing has been lost.",
  "error.noBackup.title": "Butler will not do that without a backup",
  "error.noBackup.body": "There is no verified copy to put things back from, so nothing was changed.",
  "error.ours.title": "That is our fault",
  "error.ours.body": "Something went wrong on our side. It has been recorded.",
  "empty.unknown.title": "We could not check",
  "empty.unknown.body": "This is not the same as nothing being here. Try again.",
  "empty.noMatch.title": "Nothing matches that",
  "empty.noMatch.body": "Your mail is still there; the filter is hiding it.",
  "empty.noMatch.action": "Clear the filter",
  "batch.success": "{count, plural, one {# message done} other {# messages done}}",
  "batch.partial": "{failed, plural, one {# did not go through} other {# did not go through}}, {succeeded} did.",
  "batch.failure": "{count, plural, one {# message did not go through} other {# messages did not go through}}",
  "shortcut.search": "Search",
  "shortcut.today": "Today",
  "shortcut.decisions": "Decisions",
  "shortcut.next": "Next",
  "shortcut.previous": "Previous",
  "shortcut.open": "Open",
  "shortcut.archive": "Archive",
  "shortcut.markRead": "Mark read",
  "shortcut.snooze": "Snooze",
  "shortcut.reply": "Reply",
  "shortcut.undo": "Undo",
  "shortcut.selectAll": "Select all",
  "shortcut.escape": "Close",
  "shortcut.help": "Shortcuts",
  "mail.footer.ignore": "If you were not expecting this message you can ignore it. Nobody can act on it without the link above.",
  "mail.mailbox_needs_attention.action": "Reconnect the mailbox",
  "mail.mailbox_needs_attention.body": "One of your mailboxes can no longer sign in, so new mail is not arriving. Reconnecting it takes a moment.",
  "mail.mailbox_needs_attention.heading": "A mailbox stopped syncing",
  "mail.mailbox_needs_attention.subject": "A mailbox needs reconnecting",
  "mail.reset_password.action": "Choose a new password",
  "mail.reset_password.body": "Somebody asked to reset the password for this {platform} account. The link works for {hours} hours. If it was not you, nothing has changed.",
  "mail.reset_password.heading": "Reset your password",
  "mail.reset_password.subject": "Reset your password",
  "mail.verify_email.action": "Confirm address",
  "mail.verify_email.body": "Click below to confirm this address and finish setting up your {platform} account. The link works for {hours} hours.",
  "mail.verify_email.heading": "Confirm your email address",
  "mail.verify_email.subject": "Confirm your email address",
  "mail.workspace_invitation.action": "Accept the invitation",
  "mail.workspace_invitation.body": "You have been invited to join a workspace on {platform}.",
  "mail.workspace_invitation.heading": "You have been invited",
  "mail.workspace_invitation.subject": "You have been invited to a workspace",
  "mailbox.status.active": "Active",
  "mailbox.status.auth_pending": "Waiting for sign-in",
  "mailbox.status.backing_up": "Backing up",
  "mailbox.status.backup_pending": "Backup queued",
  "mailbox.status.connected": "Connected",
  "mailbox.status.created": "Not connected",
  "mailbox.status.degraded": "Having trouble",
  "mailbox.status.disconnected": "Disconnected",
  "mailbox.status.inventory": "Counting messages",
  "mailbox.status.paused": "Paused",
  "mailbox.status.reauth_required": "Sign in again",
  "mailbox.status.rescuing": "Rescue in progress",
  "mailbox.status.snapshot_verified": "Backup verified",
  "mailboxes.add": "Connect a mailbox",
  "mailboxes.connect": "Connect",
  "mailboxes.connected": "Connected mailboxes",
  "mailboxes.disconnect": "Disconnect",
  "mailboxes.edit": "Edit",
  "mailboxes.empty.body": "Connect your first mailbox to begin. Your password is encrypted before it is stored and is never shown again.",
  "mailboxes.empty.title": "No mailbox yet",
  "mailboxes.error.body": "The request did not go through. Nothing was changed.",
  "mailboxes.error.title": "Something went wrong",
  "mailboxes.field.displayName": "Name for this mailbox",
  "mailboxes.field.email": "Email address",
  "mailboxes.field.imapHost": "IMAP server",
  "mailboxes.field.imapPort": "IMAP port",
  "mailboxes.field.password": "Password",
  "mailboxes.field.passwordHelp": "Leave the password empty to keep the current one. Saving always tests the resulting connection first.",
  "mailboxes.field.security": "Encryption",
  "mailboxes.field.smtpHost": "SMTP server (leave empty to work it out)",
  "mailboxes.field.username": "Username (leave empty to use the email address)",
  "mailboxes.form.title": "Connect a mailbox",
  "mailboxes.form.editTitle": "Edit mailbox",
  "mailboxes.intro": "Email Butler reads your mail from here. Nothing is changed in your mailbox until you say so.",
  "mailboxes.next.inventory": "Connected. Counting your messages next.",
  "mailboxes.next.ready": "Connected and ready.",
  "mailboxes.next.snapshot": "Connected. A backup is being taken before anything is touched.",
  "mailboxes.openRescue": "Open Rescue",
  "mailboxes.security.starttls": "STARTTLS",
  "mailboxes.security.tls": "TLS",
  "mailboxes.remove": "Remove",
  "mailboxes.remove.confirm": "Remove {address}? Syncing stops immediately, but indexed mail and Safety Vault backups are retained.",
  "mailboxes.returnToOnboarding": "Continue onboarding",
  "mailboxes.save": "Save and test",
  "mailboxes.test": "Test connection",
  "mailboxes.test.authFailed": "Server reached, password refused",
  "mailboxes.test.hint.auth": "The server answered but rejected the username or password. If your provider uses two-factor authentication you may need an app password.",
  "mailboxes.test.hint.host": "Check the server name and port. A firewall between here and the server would also look like this.",
  "mailboxes.test.hint.ok": "The server accepted these details. You can connect the mailbox now.",
  "mailboxes.test.ok": "Connection succeeded",
  "mailboxes.test.unreachable": "Could not reach that server",
  "mailboxes.title": "Mailboxes",
  "mailboxes.vaultVerified": "Safety Vault verified — Rescue is ready",
  "nav.admin": "Platform",
  "admin.title": "Platform",
  "admin.intro": "Settings for this deployment. Everything changed here is recorded, with who changed it and when.",
  "admin.youAre.owner": "You are an owner of this deployment.",
  "admin.youAre.admin": "You are an administrator. Only an owner can add or remove administrators.",
  "admin.youAre.operator": "You are an operator. You can see settings but not change them.",
  "admin.tab.settings": "Settings",
  "admin.tab.accounts": "Accounts",
  "admin.tab.providers": "Models",
  "admin.tab.admins": "Administrators",
  "admin.tab.audit": "Activity",
  "admin.error.title": "Something went wrong",
  "admin.error.body": "The request did not go through. Nothing was changed.",
  "admin.saved": "Saved",
  "admin.saved.body": "The change has been applied and recorded.",
  "admin.settings.title": "Deployment settings",
  "admin.accounts.title": "Create a tenant account",
  "admin.accounts.intro": "Creates the owner account and workspace together. The new owner receives a one-time link to set their own password, then starts the onboarding wizard.",
  "admin.accounts.mailRequired.title": "Outgoing mail is required",
  "admin.accounts.mailRequired.body": "Configure, enable and test platform SMTP under Settings before creating an account. The password setup link must never be shown to an administrator.",
  "admin.accounts.adminOnly": "Only a platform owner or administrator may create accounts.",
  "admin.accounts.email": "Owner email address",
  "admin.accounts.displayName": "Owner name",
  "admin.accounts.workspaceName": "Workspace name",
  "admin.accounts.workspaceSlug": "Workspace address",
  "admin.accounts.workspaceSlugHint": "Lowercase letters, digits and hyphens; for example rotz-media.",
  "admin.accounts.create": "Create account and send setup link",
  "admin.field.platformName": "Name of this deployment",
  "admin.field.supportEmail": "Support address",
  "admin.field.openRegistration": "Anyone may create an account",
  "admin.smtp.title": "Outgoing mail",
  "admin.smtp.intro": "Used for the platform's own messages: address confirmations, password resets and invitations. It is not used to send anyone's own email.",
  "admin.mail.ready": "Platform mail is configured and switched on.",
  "admin.mail.disabled": "Platform mail is configured but switched off. Nobody will receive a password reset.",
  "admin.mail.unconfigured": "Platform mail is not configured. Address confirmations and password resets cannot be sent.",
  "admin.field.smtpEnabled": "Send platform mail",
  "admin.field.smtpHost": "SMTP server",
  "admin.field.smtpPort": "SMTP port",
  "admin.field.smtpSecurity": "Encryption",
  "admin.smtp.none": "None",
  "admin.field.smtpUsername": "Username",
  "admin.field.smtpPassword": "Password",
  "admin.field.fromAddress": "From address",
  "admin.field.fromName": "From name",
  "admin.secret.stored": "A password is stored. Leave this empty to keep it.",
  "admin.secret.absent": "No password is stored.",
  "admin.smtp.test": "Send a test connection",
  "admin.smtp.ok": "The mail server accepted these details",
  "admin.smtp.failed": "The mail server refused",
  "admin.smtp.noDetail": "The server gave no reason.",
  "admin.smtp.clearPassword": "Remove the stored password",
  "admin.providers.title": "Model providers",
  "admin.providers.intro": "Registered for the whole platform. Each workspace still decides whether its mail may reach a cloud provider at all.",
  "admin.providers.empty": "No providers yet. Nothing will be classified or drafted until one is added.",
  "admin.provider.add": "Add a provider",
  "admin.provider.register": "Register",
  "admin.provider.enable": "Turn on",
  "admin.provider.disable": "Turn off",
  "admin.provider.healthy": "Working",
  "admin.provider.unhealthy": "Not answering",
  "admin.provider.off": "Off",
  "admin.locality.local": "On your own hardware",
  "admin.locality.cloud": "In the cloud",
  "admin.field.slug": "Short name",
  "admin.field.kind": "Kind",
  "admin.field.locality": "Where it runs",
  "admin.field.baseUrl": "Address",
  "admin.field.apiKey": "API key",
  "admin.field.apiKeyHint": "Encrypted before it is stored and never shown again. Leave empty for a provider that needs none.",
  "admin.field.capabilities": "Capabilities",
  "admin.field.capabilitiesHint": "Comma separated, for example: chat, embedding",
  "admin.field.priority": "Priority (lower is tried first)",
  "admin.kind.ollama": "Ollama",
  "admin.kind.vllm": "vLLM",
  "admin.kind.openai": "OpenAI",
  "admin.kind.openai_compatible": "OpenAI-compatible",
  "admin.kind.anthropic": "Anthropic",
  "admin.kind.gemini": "Gemini",
  "admin.kind.azure_openai": "Azure OpenAI",
  "admin.admins.title": "Who operates this deployment",
  "admin.admins.intro": "An administrator can change every setting here. Only an owner can add or remove administrators, which is what stops one stolen session from becoming permanent.",
  "admin.admins.grant": "Grant",
  "admin.admins.revoke": "Revoke",
  "admin.admins.ownerOnly": "Only an owner can add or remove administrators.",
  "admin.field.grantEmail": "Email address of an existing account",
  "admin.field.role": "Role",
  "admin.role.owner": "Owner",
  "admin.role.admin": "Administrator",
  "admin.role.operator": "Operator",
  "admin.audit.title": "Activity",
  "admin.audit.intro": "Every platform change, most recent first. This record cannot be edited or deleted.",
  "firstWorkspace.title": "No workspace yet",
  "firstWorkspace.body": "A workspace is where your mailboxes, rules and history live. You can add people to it later.",
  "firstWorkspace.name": "Workspace name",
  "firstWorkspace.slug": "Address",
  "firstWorkspace.slugHint": "Lowercase letters, digits and hyphens. It appears in links, so it cannot be changed later.",
  "firstWorkspace.create": "Create workspace",
  "firstWorkspace.signedInAs": "Signed in as {email}.",
  "firstWorkspace.taken": "That workspace address is already taken",
  "firstWorkspace.takenBody": "Pick a different one. Nothing was created.",
  "firstWorkspace.error": "Something went wrong",
  "firstWorkspace.errorBody": "The workspace was not created. Nothing was changed.",
  "mailboxes.connectGmail": "Connect Gmail",
  "mailboxes.connectMicrosoft": "Connect Outlook",
  "mailboxes.oauth.connected": "Mailbox connected",
  "mailboxes.oauth.connected.body": "Email Butler is reading it now. A backup is taken before anything is touched.",
  "mailboxes.oauth.declined": "Nothing was connected",
  "mailboxes.oauth.declined.body": "You did not grant access, so nothing was changed. You can try again whenever you like.",
  "mailboxes.oauth.expired": "That link had expired",
  "mailboxes.oauth.expired.body": "A connection has ten minutes to finish. Start again and nothing is lost.",
  "mailboxes.oauth.failed": "The connection did not complete",
  "mailboxes.oauth.failed.body": "The provider refused the exchange. Nothing was stored. Try again, and tell your administrator if it keeps happening.",
  "mailboxes.oauth.unconfigured": "This provider is not set up yet",
  "mailboxes.oauth.unconfigured.body": "An administrator has to add the client credentials on the Platform screen before this can be used.",
  "mailboxes.oauth.no_refresh_token": "The provider granted only temporary access",
  "mailboxes.oauth.no_refresh_token.body": "Without lasting permission the mailbox would stop syncing within the hour, so nothing was connected. Try again and accept every permission asked for.",
  "mailboxes.oauth.no_address": "The provider did not say which mailbox",
  "mailboxes.oauth.no_address.body": "Nothing was connected. This usually means the sign-in was for an account without a mailbox.",
  "wizard.title": "Add a mailbox",
  "wizard.address.help": "Start with the address. Butler works out the rest where it can, and asks only for what it cannot.",
  "wizard.continue": "Continue",
  "wizard.route.gmail": "That is a Google mailbox. The recommended way to connect it is through Google, so your password never touches Butler.",
  "wizard.route.microsoft": "That is a Microsoft mailbox. The recommended way to connect it is through Microsoft, so your password never touches Butler.",
  "wizard.imapAnyway": "Use IMAP instead",
  "wizard.note.appPassword": "This provider expects an app password",
  "wizard.note.appPassword.body": "Your normal password will likely be refused. Create an app-specific password in your provider’s security settings and use it here.",
  "wizard.note.protonBridge": "Proton needs its Bridge",
  "wizard.note.protonBridge.body": "Proton mailboxes are end-to-end encrypted and only reachable through Proton Bridge running where Butler runs. The prefilled host is the Bridge’s local address.",
  "common.back": "Back",
  "admin.oauth.title": "Gmail and Outlook",
  "admin.oauth.intro": "One registration per deployment, which every workspace connects through. Without these, people can still connect a mailbox over IMAP.",
  "admin.oauth.redirect": "Register this address with both providers as the redirect URI: {url}",
  "admin.field.googleClientId": "Google client ID",
  "admin.field.googleClientSecret": "Google client secret",
  "admin.field.microsoftClientId": "Microsoft client ID",
  "admin.field.microsoftClientSecret": "Microsoft client secret",
  "admin.field.microsoftTenant": "Microsoft directory",
  "admin.field.microsoftTenantHint": "common for any account, organizations for work accounts only, or a directory ID for one organisation.",
  "mail.obligation_reminder.subject": "Due {date}: {organisation}",
  "mail.obligation_reminder.heading": "A deadline is coming up",
  "mail.obligation_reminder.body": "{organisation} — {amount} — due {date}. This came out of your own mail; {platform} stops reminding the moment it is handled.",
  "mail.daily_digest.subject": "Your daily mail digest",
  "mail.daily_digest.heading": "What happened in your mail",
  "mail.daily_digest.body": "Cleaned up for you: {handled} messages. Deadlines in the coming week: {deadlines}. Suggestions waiting on you: {offers}. Appointments ahead: {appointments}. Subscriptions renewing: {renewals}. Problems needing a look: {problems}. The full picture is on your dashboard.",
  "digest.section.handled": "{count} messages handled for you",
  "digest.section.due": "{deadlines} deadlines and {appointments} appointments coming up",
  "digest.section.offers": "{count} suggestions waiting for your decision",
  "mail.attachment.unnamed": "Unnamed attachment",
  "mail.compose.title": "New message",
  "mail.compose.from": "From",
  "mail.compose.to": "To",
  "mail.compose.toPlaceholder": "name@example.com, another@example.com",
  "mail.compose.cc": "Cc",
  "mail.compose.subject": "Subject",
  "mail.compose.placeholder": "Your message, in your own words…",
  "mail.compose.send": "Send",
  "mail.compose.cancel": "Cancel",
  "mail.compose.sent": "Sent, and filed in your mailbox.",
  "mail.compose.failed": "Not sent. Nothing left your mailbox — check the addresses and try again.",
  "digest.section.problems": "{count} things behaving unlike themselves",
  "digest.section.renewals": "{count} subscriptions renewing this week",
  "money.title": "Money",
  "money.empty": "Nothing yet. Receipts and renewals appear here as your mail is read.",
  "money.error.title": "Could not load the money screen",
  "money.trouble.title": "Payments needing attention",
  "money.trouble.failed": "Payment failed — {vendor}",
  "money.trouble.overdue": "Overdue — {vendor}",
  "money.trouble.deadline": "act before {date}",
  "money.spend.title": "Monthly spend",
  "money.spend.perMonth": "per month",
  "money.spend.detail": "{count} subscriptions, {irregular} irregular and outside the total",
  "money.subscriptions.title": "Subscriptions",
  "money.timeline.title": "Coming out of your account",
  "money.timeline.empty": "Nothing due in the next 45 days.",
  "money.timeline.estimated": "estimated",
  "money.cadence.weekly": "weekly",
  "money.cadence.monthly": "monthly",
  "money.cadence.quarterly": "quarterly",
  "money.cadence.yearly": "yearly",
  "money.cadence.irregular": "irregular",
  "money.status.active": "active",
  "money.status.lapsed": "lapsed",
  "money.status.cancelled": "cancelled",
  "money.status.unknown": "unknown",
  "today.appointment.accept": "Accept",
  "today.appointment.tentative": "Maybe",
  "today.appointment.decline": "Decline",
  "today.appointment.response.accepted": "You accepted",
  "today.appointment.response.declined": "You declined",
  "today.appointment.response.tentative": "You said maybe",
  "search.title": "Search",
  "search.label": "Find a message",
  "search.placeholder": "an invoice number, a name, or what it was about",
  "search.hint": "Searches the words in your mail and their meaning, together.",
  "search.submit": "Search",
  "search.results": "{count} results for “{query}”",
  "search.noResults": "Nothing found for “{query}”",
  "search.hasAttachments": "has attachments",
  "search.keywordOnly": "Searching words only — the meaning search is unavailable right now.",
  "search.matched.keyword": "your words",
  "search.matched.semantic": "the meaning",
  "search.matched.both": "both",
  "search.error.title": "Could not search",
  "search.error.body": "Nothing was lost. Try again in a moment.",
  "activity.title": "What Butler did",
  "activity.subtitle": "Every action, newest first. Anything reversible can be put back.",
  "activity.empty": "Butler has not done anything yet.",
  "activity.counts": "{count} of {total} messages",
  "activity.failed": "{count} failed",
  "activity.status.undone": "undone",
  "activity.action.archive": "archived",
  "activity.action.mark_read": "marked read",
  "activity.action.trash": "moved to trash",
  "activity.action.delete": "deleted",
  "activity.action.move": "moved",
  "activity.undo.do": "Undo",
  "activity.undo.working": "Putting back…",
  "activity.undo.done": "Put back {count} messages.",
  "activity.undo.partial": "Put back {count} messages; {failed} could not be moved.",
  "activity.undo.failed": "Nothing was changed. Try again in a moment.",
  "activity.undo.already": "already undone",
  "activity.undo.cannot": "cannot be undone",
  "activity.error.title": "Could not load what Butler did",
  "mail.draft.suggest": "Suggest a reply",
  "mail.draft.working": "Writing…",
  "mail.draft.ready": "A suggestion is in the box. Read it, change what you want, then send.",
  "mail.draft.readyWithWarnings": "Suggestion ready — read carefully: {warnings}.",
  "mail.draft.failed": "Could not write a suggestion. Your own words still work.",
  "mail.draft.tone": "Tone",
  "mail.draft.tone.neutral": "Neutral",
  "mail.draft.tone.friendly": "Friendly",
  "mail.draft.tone.formal": "Formal",
  "mail.draft.tone.brief": "Brief",
  "mail.draft.tone.warm": "Warm",
  "mail.draft.warning.contains_commitment": "it promises something",
  "mail.draft.warning.apologises_unprompted": "it apologises unprompted",
  "mail.draft.warning.mentions_assistant": "it mentions being written by an assistant",
  "mail.draft.warning.quotes_the_message": "it quotes the message back",
  "mail.draft.warning.has_placeholder": "it left a placeholder to fill in",
  "mail.draft.warning.empty": "it came back empty",
  "mail.draft.warning.too_long": "it is very long",
  "today.doors.offers": "{count} suggestions are waiting for your answer",
  "today.doors.offers.badge": "asks you",
  "today.doors.offers.action": "Go through them",
  "today.doors.money": "{count} payments need attention",
  "today.doors.money.badge": "money",
  "today.doors.money.action": "Open money",
  "today.doors.anomalies": "{count} things are behaving unlike themselves",
  "today.doors.anomalies.badge": "unusual",
  "today.doors.anomalies.action": "See what happened",
  "butler.title": "Ask Butler",
  "butler.subtitle": "Questions about your own mail, answered only from your own mail.",
  "butler.label": "What would you like to know?",
  "butler.placeholder": "what did the lease company ask me to pay?",
  "butler.hint": "Every answer lists the messages it was drawn from, so you can check it.",
  "butler.ask": "Ask",
  "butler.thinking": "Reading your mail…",
  "butler.startOver": "Start a new conversation",
  "butler.readFrom": "Answered from {cited} of {retrieved} messages it read.",
  "butler.failed": "Could not answer that just now. Nothing was changed.",
  "butler.status.not_found": "Nothing in your mail answers that, so Butler will not guess.",
  "butler.status.refused": "That question is too long or too short to answer.",
  "butler.status.failed": "The answer could not be produced. Try asking again.",
  "waiting.title": "Who is waiting",
  "waiting.subtitle": "Promises found in your mail — theirs to you, and yours to them.",
  "waiting.owedToYou": "They owe you",
  "waiting.owedToYou.empty": "Nobody owes you anything Butler can find.",
  "waiting.youOwe": "You owe them",
  "waiting.youOwe.empty": "You have not promised anything Butler can find.",
  "waiting.done": "Done",
  "waiting.dismiss": "Not a promise",
  "waiting.assumed": "assumed date",
  "waiting.error.title": "Could not load who is waiting"
}
